<template>
  <div>
    <features>
      <template v-slot:header>
        <div>
          <h1 class="display-2 text-white font-weight-bold mb-0">
            A centralized uptime & incident dashboard
          </h1>
          <h2 class="display-4 text-white font-weight-light">
            Give employees one source of truth with a centralized, private
            status page.
          </h2>
          <p class="text-white mt-4">
            Important IT communication through email doesn't cut it anymore.
            With automated uptime monitoring and incident declaration, your
            employees can have peace of mind with BoltScale.
          </p>
        </div>
      </template>
      <template v-slot:hero-image>
        <b-img src="/img/dashboard.svg" />
      </template>
      <template v-slot:second>
        <b-col md="6">
          <h2 class="display-3 text-white" style="font-weight: 600;">
            Say hello to centralized
            <span class="text-success" style="font-weight: 600;">
              incident management.
            </span>
          </h2>
          <p class="lead text-white mb-6">
            Keep your employees informed on the performance of critical systems.
            Automatically notify Slack channels with incidents from your
            services (or your dependencies).
          </p>
        </b-col>
      </template>

      <template v-slot:feature-breakdown>
        <section class="py-6">
          <b-container>
            <b-row align-v="center" class="row-grid">
              <b-col md="6" class="order-md-2 features-col">
                <b-img src="/img/slack.svg" fluid />
              </b-col>
              <b-col md="6" class="col-md-6">
                <div class="pr-md-5">
                  <h1>Get Notified on Slack & Beyond</h1>
                  <p>
                    When incidents happen, response time & transparency is
                    important. Set up Slack channels or email notifications to
                    ensure the right people are aware of issues as early as
                    possible.
                  </p>
                </div>
              </b-col>
            </b-row>
          </b-container>
        </section>

        <section class="py-6">
          <b-container>
            <b-row align-v="center" class="row-grid">
              <b-col md="6" class="features-col">
                <b-img src="/img/github.svg" fluid />
              </b-col>
              <b-col md="6" class="col-md-6">
                <div class="pr-md-5">
                  <h1>
                    Incidents from Third-Party Services
                  </h1>
                  <p>
                    BoltScale integrates with the status pages of hundreds of
                    third-party services, such as
                    <a target="blank" href="https://www.githubstatus.com/#">
                      GitHub
                    </a>
                    ,
                    <a target="blank" href="https://status.digitalocean.com/">
                      Digital Ocean
                    </a>
                    , and and
                    <a target="blank" href="https://status.sendgrid.com/">
                      SendGrid
                    </a>
                    . Display the status of these services on your status page,
                    and automatically get updates when one of these services
                    declare an issue.
                  </p>
                </div>
              </b-col>
            </b-row>
          </b-container>
        </section>
      </template>
    </features>
  </div>
</template>

<script>
//import AsyncWorldMap from "@/components/WorldMap/AsyncWorldMap.vue";
import Features from "@/views/Pages/Features/Features";

//import { Tooltip } from "element-ui";
export default {
  name: "why-boltscale",
  components: {
    Features
    //   AsyncWorldMap,
    // [Tooltip.name]: Tooltip
  }
};
</script>

<style>
.iphone-hero-img {
  height: 300px;
  width: auto;
}
.card-snippet {
  text-align: center;
}
.main-content {
  overflow: hidden;
}

.features-col {
  text-align: center;
}

.features-col img {
  max-width: 300px;
}

.hero-image {
  margin-top: 25px;
  width: 800px;
  margin-bottom: -94px;
  box-shadow: 0 1rem 3rem rgba(0, 0, 0, 0.175) !important;
  /*box-shadow: 1px 1px 100px 51px rgba(25, 43, 77, 0.1);*/
}
</style>
